import Node from './shared/Node';

export default class Comment extends Node {
	type: 'Comment'
}